<template>
    <div id="fhlMidWindow">
        <nui-lecture></nui-lecture>
        <nui-bottom></nui-bottom>
    </div>
</template>

<script>
import NuiLecture from '../components/NuiLecture'
import NuiBottom from '../components/NuiBottom'

export default {
    data() {
        return {}
    },
    components: {
        NuiLecture,
        NuiBottom
    }
}
</script>


// WEBPACK FOOTER //
// src/layouts/NuiMiddleWindow.vue